import axios from "axios";

// const BASE_URL = "http://10.1.2.38:3000/api/";
// const BASE_URL = "https://crm.millergroup.it/api/";

const DEFAULT_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3002/api/"
    : "https://crm.millergroup.it/api/";

const BASE_URL = process.env.REACT_APP_BASE_URL || DEFAULT_BASE_URL;
const APP_BASENAME = process.env.REACT_APP_BASENAME || "";
const LOGIN_URL = `${APP_BASENAME}/`.replace("//", "/");

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Request Interceptor: aggiunge access token all'header
api.interceptors.request.use(
  (config) => {
    const accessToken = window.localStorage.getItem("accessToken");
    // if (accessToken && !config.headers['Authorization']) {
    //   config.headers['Authorization'] = `Bearer ${accessToken}`;
    // }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: gestisce errori di autenticazione
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Se riceve "invalid token", effettua logout
    if (error?.response?.data?.message === "invalid token") {
      console.warn("Token invalido, effettuo logout");
      ['accessToken', 'username', 'permission', 'pic', 'id', 'cpt_auth'].forEach(k => window.localStorage.removeItem(k));
      window.location.href = LOGIN_URL;
      return Promise.reject(error);
    }

    // Un 403 restituito dai controlli di ruolo significa "permesso negato",
    // non "sessione scaduta": non tentare il refresh e non scollegare l'utente.

    return Promise.reject(error);
  }
);

export default api;
